import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

export const useListSimIpb = ({
  purchaseOrderListIpbAction,
  purchaseOrderDetailListIpbAction,
  cleanPurchaseOrderListClean,
  purchaseOrderListIpb,
  purchaseOrderListDetailsIpb,
  cleanDetailPurchaseOrderListIpbAction,
  transactionId,
  onClose,
}) => {
  const { payload } = purchaseOrderListIpb || {};
  const { response } = purchaseOrderListDetailsIpb || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(false);
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [action, setAction] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [error, setError] = useState(false);
  const [IdOrder, setIDorder] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      purchaseOrderListIpbAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      cleanPurchaseOrderListClean();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, purchaseOrderListIpbAction, cleanPurchaseOrderListClean]);

  useEffect(() => {
    if (purchaseOrderListIpb?.status === 200) {
      setLoading(false);
    } else if (purchaseOrderListIpb?.payload?.response?.status > 200) {
      setDialogMessage(purchaseOrderListIpb?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [purchaseOrderListIpb]);

  useEffect(() => {
    if (page === 0) {
      return;
    }

    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      purchaseOrderListIpbAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size]);

  const onSubmit = (data) => {
    const { from_date, to_date, authorization_code, masked_pan_termination } = data;

    const areDatesProvided = from_date !== '' && to_date !== '';
    const isAuthorizationOrCardProvided =
      authorization_code !== '' || masked_pan_termination !== '';

    if (areDatesProvided || isAuthorizationOrCardProvided) {
      setLoading(true);
      const filteredData = Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(data).filter(([_, value]) => value !== ''),
      );
      setSearchParams(filteredData);
      setErrorMessage('');
    } else {
      setErrorMessage(
        'Por favor, complete al menos uno de los siguientes campos: autorización, tarjeta o ambas fechas.',
      );
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row, idx) => ({
        ...row,
        id: row.id ?? row.order_id ?? idx,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setIDorder(id);
    if (id) {
      setIsDialogOpenDetails(true);
      purchaseOrderDetailListIpbAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        cleanDetailPurchaseOrderListIpbAction();
      };
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    cleanDetailPurchaseOrderListIpbAction();
    if (transactionId) {
      onClose();
    }
  };

  const handleOpenPopUp = (action, rowId) => {
    setAction(action);
    setSelectedRowId(rowId);
    setOpenActionFraud(true);
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
    }
  };

  const Columns = [
    {
      field: 'order_id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button variant='outlined' onClick={() => handleIdButtonClick(params.row.order_id)}>
          Ver detalle
        </Button>
      ),
    },
    {
      field: 'created',
      headerName: 'Fecha DB',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'sim_type',
      headerName: 'Tipo de SIM',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'order_number',
      headerName: 'Número de orden',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nombre',
      headerName: 'Nombre del cliente',
      width: 220,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'contact_phone',
      headerName: 'Número de contacto',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  return {
    selectedRowId,
    action,
    IdOrder,
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    handleConfirm,
    // handleCloseFraudChargeback,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    error,
    handleOpenPopUp,
    setLoading,
  };
};
